import React, { useState, useEffect } from "react";
import s from "./categorySection.module.scss";

interface CategorySectionProps {
  editableCategories: (string | number)[] | null;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  hasError: boolean;
}

const categories = [
  { id: 1, name: "Спорт" },
  { id: 2, name: "Музыка" },
  { id: 3, name: "Образование" },
  { id: 4, name: "Здоровье" },
  { id: 5, name: "Культура" },
  { id: 6, name: "Отдых" },
  { id: 7, name: "IT" },
  { id: 8, name: "Другое" },
];

export const CategorySection: React.FC<CategorySectionProps> = ({ editableCategories, setFormData, hasError }) => {
  // Установка изначального массива выбранных категорий при редактировании   и при создании
  const initialActiveButtons = editableCategories ? editableCategories.map(Number) : [];
  const [activeButtons, setActiveButtons] = useState<number[]>(initialActiveButtons);
  const [maxCategoriesReached, setMaxCategoriesReached] = useState(false);

  useEffect(() => {
    setFormData((prev: any) => ({
      ...prev,
      categories: activeButtons,
    }));
    setMaxCategoriesReached(activeButtons.length >= 5);
  }, [activeButtons, setFormData]);

  const toggleButton = (categoryId: number) => {
    if (activeButtons.includes(categoryId)) {
      // Если категория уже выбрана - убираем ее
      setActiveButtons(prev => prev.filter(id => id !== categoryId));
    } else {
      // Если категория не выбрана и не достигнут лимит - добавляем
      if (activeButtons.length < 5) {
        setActiveButtons(prev => [...prev, categoryId]);
      }
    }
  };

  const showError = hasError && activeButtons.length === 0;

  return (
    <div className={s.categorySection}>
      <h2 className={s.sectionTitle}>Категория*</h2>

      <div className={s.categories}>
        <div className={s.firstCategories}>
          {categories.slice(0, 4).map((category) => (
            <button
              key={category.id}
              type="button"
              className={`${s.categoryButton} ${
                activeButtons.includes(category.id) ? s.active : ""
              } ${maxCategoriesReached && !activeButtons.includes(category.id) ? s.disabled : ""}`}
              onClick={() => toggleButton(category.id)}
              disabled={maxCategoriesReached && !activeButtons.includes(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div className={s.secondCategories}>
          {categories.slice(4).map((category) => (
            <button
              key={category.id}
              type="button"
              className={`${s.categoryButton} ${
                activeButtons.includes(category.id) ? s.active : ""
              } ${maxCategoriesReached && !activeButtons.includes(category.id) ? s.disabled : ""}`}
              onClick={() => toggleButton(category.id)}
              disabled={maxCategoriesReached && !activeButtons.includes(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        {showError && (
          <p className={s.errorText}>Укажите хотя бы одну категорию!</p>
        )}

        {maxCategoriesReached && (
          <p className={s.errorText}>Максимум 5 категорий</p>
        )}
      </div>
    </div>
  );
};